module.exports = "/shared/img/rubbish-red-blue.svg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/rubbish-red-blue.svg
// module id = 446
// module chunks = 13